import React, { useRef } from "react";
import { connect } from "react-redux";
import {
  FilterModes,
  SearchModes,
  setActiveSearchMode,
  updateResults,
  updateAlternatePage,
  redirectToGeneralSearch
} from "../../store/actions";

const SearchModeTabs = (props) => {
  let defaultRef = useRef(null);
  if (props.searchExecuted && props.countSearchResults === 0 && props.countAlternativeResults > 0 && props.activeSearchMode !== SearchModes.ALTERNATIVE) {
    props.setActiveSearchMode(SearchModes.ALTERNATIVE);
    props.updateResults(true);
    if (defaultRef.current !== null) {
      defaultRef.current.blur();
    }
  }

  /**
   * handler for finder results tab
   * @param {*} event 
   */
  const handleClickSearchModeTable = (event) => {
    props.setActiveSearchMode(SearchModes.TABLE);
    event.preventDefault();
  };
  /**
   * handler for alternative results tab
   * @param {*} event 
   */
  const handleClickSearchModeAlternative = (event) => {
    
    /**
     * REFRACTOR 
     * 
     * dont render alternative search results instead
     * redirect to general search page
     * */
    //props.setActiveSearchMode(SearchModes.ALTERNATIVE);
    //props.updateAlternatePage(0);
    //props.updateResults(true); 

    // passing withResult=false to indicate to dismiss rendering of results
    //props.updateResults(false);


    props.redirectToGeneralSearch();

    event.preventDefault();
  };


  return props.render && (
    <ul className="theme-tabs tabs--full">
      <li className="default-search table">
        {/* <a ref={defaultRef} className={props.activeSearchMode === SearchModes.TABLE ? 'is-active' : ''} href="#" onClick={handleClickSearchModeTable}> */}
        <a ref={defaultRef} className="is-active" href="#" onClick={handleClickSearchModeTable}>
          {props.strings['STRING:SEARCH_COUNT_PRODUCT_RESULTS'].replace('!count', props.countSearchResults)}
        </a>
      </li>
      <li className="alternate-search results">
        {/* <a className={props.activeSearchMode === SearchModes.ALTERNATIVE ? 'is-active' : ''} href="#" onClick={handleClickSearchModeAlternative}> */}
        <a className="" href="#" onClick={handleClickSearchModeAlternative}>
          {props.strings['STRING:SEARCH_COUNT_ALTERNATIVE_RESULTS'].replace('!count', props.countAlternativeResults)}
        </a>
      </li>
    </ul>
  );
};

const mapStateToProps = (state) => {
  return {
    render: !!(state.results.searchExecuted && state.parameters.mode === FilterModes.SEARCH_MODE),
    searchExecuted: state.results.searchExecuted,
    activeSearchMode: state.parameters.activeSearchMode,
    countSearchResults: state.results.count ? state.results.count : 0,
    countAlternativeResults: state.results.countAlternative ? state.results.countAlternative : 0,
  }
};

export default connect(
  mapStateToProps,
  { setActiveSearchMode, updateResults, updateAlternatePage, redirectToGeneralSearch }
)(SearchModeTabs)
